module.exports = __webpack_public_path__ + "img/logo2 (1).15556355.png";